import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { environment } from '../../../environments/environment';

const firebaseApp = initializeApp(environment.firebase);
const messaging = getMessaging(firebaseApp);

export { messaging };